import GoogleLoginBtn from "../GoogleAuth/GoogleLoginBtn";
import "./Login.css";

const Login = () => {
    return (
        <div className="container">
            <GoogleLoginBtn />
        </div>
    );
};

export default Login;
